import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
// Types
import UserRoles from 'app/types/UserRoles';
// Models
import { IMyUser } from 'app/models/User';
// Redux
import { useAppSelector } from 'app/hooks/useStore';
// Selectors
import { selectTrialMode } from 'app/store/AppUI/AppUI.selectors';
import { selectMyUser } from 'app/store/Users/Users.selectors';
// Mui
import { Tooltip } from '@mui/material';
// Components
import { IconButton } from 'app/components/Mui';
// Icons
import { Add as AddIcon } from '@mui/icons-material';
// hooks
import useToggle from 'app/hooks/useToggle';
import useCaseStatus from 'app/hooks/useCaseStatus';
import useAccountStatus from 'app/hooks/useAccountStatus';
// 
import EpisodesFormDialog from './EpisodeFormDialog';
// Context
import { usePageEpisodesContext } from 'app/context/PageEpisodes.context';
// ToDO
import { IPage } from '@root/models/Page';
import { selectPage } from 'app/store/page/page.selectors';
// End: ToDO

const CreateEpisodeButton = () => {
  const { t } = useTranslation();
  // State
  const trialMode = useAppSelector(selectTrialMode);
  const myUser = useAppSelector(selectMyUser) as IMyUser;
  // ToDO
  const page = useAppSelector((state) => selectPage(state as any)) as IPage;
  // End: ToDO
  const { isArchived } = useCaseStatus();
  const { isSuspended } = useAccountStatus();
  const { open, toggle } = useToggle();
  const { isPageRoute } = usePageEpisodesContext();

  const myRolePresenterOrClient = myUser.role === UserRoles.Presenter || myUser.role === UserRoles.Client;

  if ( myRolePresenterOrClient || trialMode ) return null;
  if ( isArchived || (page && page.staple && (page.staple.order !== 1 && !isPageRoute))) return null;
  return (
    <Fragment>
      <Tooltip title={t('components.pageEpisodes.createButton')}>
        <IconButton
          name="Create episode"
          className="create-episode-icon-button"
          onClick={toggle}
          size="small"
          disabled={isSuspended}
        ><AddIcon /></IconButton>
      </Tooltip>
      {open ? (
        <EpisodesFormDialog
          open={open}
          onClose={toggle}
        />
      ) : null}
    </Fragment>
  )
}

export default CreateEpisodeButton;
